import { ASSET_TYPES } from "../../enums/assetTypes.enum";

export function pathToAssetType(type: string) {
  switch (type) {
    case "customer":
      return ASSET_TYPES.CUSTOMER;
    case "location":
      return ASSET_TYPES.LOCATION;
    case "building":
      return ASSET_TYPES.BUILDING;
    case "gateSystem":
      return ASSET_TYPES.DOOR;
    default:
      return null;
  }
}

export function getAssetChildrenType(parentType: string | null): ASSET_TYPES | null {
  switch (parentType) {
    case ASSET_TYPES.TENANT:
      return ASSET_TYPES.CUSTOMER;
    case ASSET_TYPES.CUSTOMER:
      return ASSET_TYPES.LOCATION;
    case ASSET_TYPES.LOCATION:
      return ASSET_TYPES.BUILDING;
    case ASSET_TYPES.BUILDING:
      return ASSET_TYPES.DOOR;
    case ASSET_TYPES.DOOR:
      return null;
    default:
      return null;
  }
}

export function getAssetParentType(childrenType: string | null): string | null {
  switch (childrenType) {
    case ASSET_TYPES.DOOR:
      return ASSET_TYPES.BUILDING;
    case ASSET_TYPES.BUILDING:
      return ASSET_TYPES.LOCATION;
    case ASSET_TYPES.LOCATION:
      return ASSET_TYPES.CUSTOMER;
    case ASSET_TYPES.CUSTOMER:
      return ASSET_TYPES.TENANT;
    case ASSET_TYPES.TENANT:
      return null;
    default:
      return null;
  }
}

export function isBotevoAssetType(type: string) {
  return (
    type === ASSET_TYPES.TENANT ||
    type === ASSET_TYPES.CUSTOMER ||
    type === ASSET_TYPES.LOCATION ||
    type === ASSET_TYPES.BUILDING ||
    type === ASSET_TYPES.DOOR
  );
}
